var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEstimates = function SvgEstimates(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 21.4614C19.9998 21.849 19.8459 22.2207 19.5718 22.4948C19.2977 22.7689 18.9259 22.9229 18.5383 22.9229H2.46153C2.07391 22.9229 1.70216 22.7689 1.42807 22.4948C1.15398 22.2207 1 21.849 1 21.4614V2.46153C1 2.07391 1.15398 1.70216 1.42807 1.42807C1.70216 1.15398 2.07391 1 2.46153 1H12.8179C13.2053 1.00008 13.5767 1.15393 13.8507 1.42774L19.5721 7.14913C19.8459 7.42312 19.9998 7.79459 19.9998 8.18194V21.4614Z",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 8.30759H14.1536C13.7659 8.30759 13.3942 8.15361 13.1201 7.87952C12.846 7.60543 12.692 7.23368 12.692 6.84606V0.999954",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84779 11.5662C5.05881 11.8433 5.33352 12.0655 5.64866 12.2139C5.9638 12.3624 6.31008 12.4326 6.65814 12.4187C7.76792 12.4187 8.66822 11.7435 8.66822 10.9114C8.66822 10.0793 7.77085 9.40507 6.66204 9.40507C5.55322 9.40507 4.65292 8.72985 4.65292 7.89678C4.65292 7.06371 5.55322 6.38946 6.66204 6.38946C7.01013 6.37535 7.35649 6.44549 7.67167 6.59392C7.98685 6.74235 8.26153 6.96468 8.47238 7.24201",
    stroke: "#8390A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6627 12.4184V13.4229",
    stroke: "#8390A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6627 5.3848V6.38935",
    stroke: "#8390A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 14.8844H16.3464",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38618 19.2693H16.3476",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEstimates, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/estimates.43032b08.svg";
export { ForwardRef as ReactComponent };